/**
 * connectorLabels — Spanish display names for connector kinds.
 *
 * Single source of truth so the same string lands on Hire cards, Dashboard
 * roster pills, the agent's profile tags, and the OAuth-return tab. Falls back
 * to the kind verbatim with `_` → space for any unmapped connector.
 *
 * Some surfaces (the OAuth-return tab) have room for the full product name; for
 * those, pass `{ long: true }` to read `LONG_MAP` where a long form exists,
 * falling back to the short label otherwise.
 */
const MAP: Record<string, string> = {
  tiendanube: "TiendaNube",
  meta_ads: "Meta Ads",
  google_ads: "Google Ads",
  google_analytics_4: "GA4",
  tiktok_ads: "TikTok Ads",
  mercadolibre: "Mercado Libre",
  mercado_envios: "Mercado Envíos",
  klaviyo: "Klaviyo",
  doppler: "Doppler",
  active_campaign: "ActiveCampaign",
  xubio: "Xubio",
  contabilium: "Contabilium",
  tango: "Tango",
  xero: "Xero",
  quickbooks: "QuickBooks",
  andreani: "Andreani",
  correo_argentino: "Correo Argentino",
  oca: "OCA",
};

// Long-form names for surfaces with room for the full product name.
const LONG_MAP: Record<string, string> = {
  google_analytics_4: "Google Analytics 4",
};

export function connectorLabelEs(
  kind: string,
  opts?: { long?: boolean },
): string {
  if (!kind) return "Fuente";
  if (opts?.long && LONG_MAP[kind]) return LONG_MAP[kind];
  return MAP[kind] ?? kind.replaceAll("_", " ");
}
